function a(a,c,f,n){a._m(c);var o=f("678972fc");a._(c,"AppLayout",o);}